import { makeStyles, Box } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import BackForwardButton from '../../Shared/BackForwardButton';
import ProductionStateLineTable from '../../ProductionState/ProductionStateLineTable';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { dataService } from '../../../Services/data.service';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';

export const ProductionStatePage = (props) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const [productionState, setProductionState] = useState(null);
    const [productionOrder, setProductionOrder] = useState(null);
    let history = useHistory();


    useEffect(() => {
        dataService.getProductionStateByMachineId(parseInt(props.workstation.selectedWorkstation)).then(productionState => {
            if (productionState) {
                console.log(productionState)
                let tempProductionState = productionState;
                var polIds = [];
                tempProductionState.forEach(state => {
                    if (state.productionOrderLineId !== null && !polIds.some(x => x === state.productionOrderLineId)) {
                        polIds.push(state.productionOrderLineId);
                    }
                });
                const uniqueNumbers = [...new Set(polIds)];
                dataService.getAllProductionOrdersByIdList(uniqueNumbers).then(result => {
                    tempProductionState.forEach(state => {
                        if (result.some(order => order.orderLineId === state.productionOrderLineId)) {
                            let order = result.find(order => order.orderLineId === state.productionOrderLineId);
                            state.reference = order.reference;
                            state.quantity = order.quantity;
                            state.quantityOnCarrier = order.quantityOnCarrier;
                            state.quantityToProduce = order.quantityToProduce;
                            state.productName = order.productName;
                            state.productDescription = order.productDescription;
                            state.bomOut = order.bomOut;
                            state.bomIn = order.bomIn;
                        }
                    });
                    setProductionState(tempProductionState.sort((a, b) => new Date(b.insertedOn) - new Date(a.insertedOn)))
                }).catch((error) => { toast.error(error, { position: "top-center" }) });
            }
        }).catch((error) => { toast.error(error, { position: "top-center" }) });


        dataService.getOrderDetailsByOrderId(parseInt(props.match.params.id)).then(order => {
            setProductionOrder(order);
        }).catch((error) => { toast.error(error, { position: "top-center" }) });
    }, [props.match.params.id, props.match.params.machineId, props.workstation.selectedWorkstation]);

    const goToOrder = () => {
        history.push('/order/' + props.match.params.id + '/' + props.match.params.orderLineId);
    }

    let line = "";
    // let dimensions = "";
    // let palletprogress = "";
    // let articleName = "";
    // let articleDescription = "";
    // let totalPallets = "";
    // let producedPieces = "";
    // let totalPieces = "";
    // let quality = "";²
    // if (productionOrder) {
    //     var productMetaDataType1 = JSON.parse(productionOrder.bomOut[0].productMetaData).find(x => x.MetaDataType === 1);
    //     var productMetaDataType2 = JSON.parse(productionOrder.bomOut[0].productMetaData).find(x => x.MetaDataType === 2);
    //     line = productionOrder.machineCode;
    //     dimensions = productMetaDataType1.MetaData[0].Width.Value + "x" + productMetaDataType1.MetaData[0].Length.Value + "x" + productMetaDataType1.MetaData[0].Thickness.Value;
    //     quality = productMetaDataType2.MetaData[0].Quality;
    //     palletprogress = props.match.params.progress;
    //     articleName = productionOrder.bomOut[0].productName;
    //     articleDescription = productionOrder.bomOut[0].productDescription;
    //     totalPieces = productionOrder.bomOut[0].quantityToProduce;
    //     producedPieces = parseInt(props.match.params.progress) * productionOrder.bomOut[0].quantityOnCarrier;
    //     if (producedPieces > totalPieces) {
    //         producedPieces = totalPieces;
    //     }
    //     totalPallets = Math.ceil(productionOrder.bomOut[0].quantityToProduce / productionOrder.bomOut[0].quantityOnCarrier);
    // }

    return (
        <React.Fragment>{
            productionOrder ?
                <div className={classes.background}>
                    <div className={classes.qualityChecks}>
                        <div className={classes.header}>
                            <div className={classes.left}>
                                <div className={classes.back}>
                                    <BackForwardButton textOverride={t("Back to order ") + productionOrder.reference} action={goToOrder} direction={'Back'}></BackForwardButton>
                                </div>
                                <div className={classes.subTitle}>
                                    {t("Productionstate Line") + " " + line}
                                </div>
                            </div>
                        </div>
                        <div className={classes.generalInfoContainer}>
                            {productionState?.length > 0 ?
                                <ProductionStateLineTable rows={productionState} props={props} />
                                : <Box style={{ "padding": "5px" }}>{t("No production state registered")}</Box>}
                        </div>
                    </div>
                </div>
                : <div>Loading...</div>}
        </React.Fragment>
    )
}

const useStyles = makeStyles({
    filterBar: {
        width: "210px",
        backgroundColor: "#DEDEDE",
        float: "left",
        height: "100%",
        padding: "20px",
        paddingLeft: "0px",
        paddingTop: "30px",
        boxSizing: 'border-box'
    },
    qualityChecks: {
        width: "100%",
        float: "left",
        padding: "15px",
        boxSizing: 'border-box',
        display: 'flex', flexDirection: 'column'
    },
    navButton: {
        textDecoration: "none"
    },
    back: {
        display: 'block'
    },
    title: {
        display: 'block',
        fontSize: "22px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",
        marginLeft: "5px",
        marginTop: "10px",
        marginBottom: "10px"
    },
    subTitle: {
        display: 'block',
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",
        marginLeft: "5px",
        marginBottom: "10px"
    },
    underTitle: {
        display: 'block',
        fontSize: "22px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",
        marginLeft: "5px"
    },
    right: {
        float: 'right'
    },
    left: {
        float: "left"
    },
    buttonText: {
        color: 'white',
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        float: "left",
        paddingTop: "2px",
        marginLeft: "2px",
        marginRight: "5px"

    },
    generalInfoContainer: {
        borderRadius: "6px",
    },
    header: {
    },
    background: {
        paddingTop: "20px",
        position: "relative",
        width: "100%"
    },
});

function mapStateToProps(state) {
    return {
        workstation: state.workstation
    }
}

export default connect(mapStateToProps)(ProductionStatePage)